"use strict";Object.defineProperty(exports, "__esModule", {value: true});var PendingFilter; (function (PendingFilter) {
  const ALL = '*'; PendingFilter["ALL"] = ALL;
  const PENDING = 'true'; PendingFilter["PENDING"] = PENDING;
})(PendingFilter || (exports.PendingFilter = PendingFilter = {}));
